import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Loadable from 'react-loadable';

import { useGlobalLoading } from 'Utils/GlobalLoading';

import { REMOTE_FEATURE_FLAG_PROVIDER_ID } from 'Services/FeatureFlags/featureFlagProviders/RemoteFeatureFlagProvider';
import useFeatureFlagsProvider from './useFeatureFlagsProvider';

const ErrorPage = Loadable({
  loader: () => import(
    /* webpackChunkName: "ErrorPage" */
    'Components/Errors/RequestError'
  ).then(cp => cp.RequestError),
  loading: () => null,
  modules: ['Pager'],
});

export const FeatureFlagsProvider = ({
  children, loading,
}) => {
  const { isReady, errors } = useFeatureFlagsProvider();
  const { startLoading, endLoading } = useGlobalLoading(['ASYNC_FEATURE_FLAGS']);

  useEffect(() => {
    if (isReady) endLoading();
    else startLoading();
  }, [isReady]);

  if (!isReady) return loading ?? null;
  if (errors.has(REMOTE_FEATURE_FLAG_PROVIDER_ID)) return <ErrorPage />;
  return children;
};

FeatureFlagsProvider.propTypes = {
  children: PropTypes.node,
  loading: PropTypes.node,
};

FeatureFlagsProvider.defaultProps = {
  children: null,
  loading: null,
};
